import { jsxs as r, jsx as l } from "react/jsx-runtime";
const h = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M29.616 55.216c-6.378 0-11.567-5.189-11.567-11.567 0-3.29 1.38-6.263 3.593-8.37l-.005-3.81c-3.964 2.605-6.588 7.092-6.588 12.18 0 8.032 6.535 14.567 14.567 14.567 4.55 0 8.62-2.098 11.293-5.377l-1.054-3.814c-1.939 3.678-5.8 6.19-10.239 6.19ZM29.377 18.945a6.513 6.513 0 0 1-6.505-6.505 6.512 6.512 0 0 1 6.505-6.505 6.512 6.512 0 0 1 6.505 6.505 6.513 6.513 0 0 1-6.505 6.505Zm0-10.01a3.51 3.51 0 0 0-3.505 3.505 3.51 3.51 0 0 0 3.505 3.505 3.51 3.51 0 0 0 3.505-3.505 3.51 3.51 0 0 0-3.505-3.505Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M48.147 53.057h-2.51L42.08 40.182H26.53a.384.384 0 0 1-.383-.383l-.02-16.406 3.225-.855 3.225.855v7.945c0 1.02.83 1.849 1.85 1.849h5.75l-.804-3h-3.796v-9.103l-6.225-1.65-6.228 1.65.023 18.719a3.388 3.388 0 0 0 3.384 3.379h13.266l3.557 12.875h5.597l-.804-3Z"
        }
      )
    ]
  }
);
export {
  h as DisbaledToilet
};
